module.exports = __webpack_public_path__ + "img/danielazamora.0376177a.jpg";